import deepFreeze from 'deep-freeze';

export const GENDER_OPTIONS = Object.freeze([
  {
    value: 0,
    label: 'Onbekend',
  },
  {
    value: 1,
    label: 'Man',
  },
  {
    value: 2,
    label: 'Vrouw',
  },
]);

export const region = deepFreeze({
  NL: 1,
  BE: 2,
});
